import api from "./api";

export const onboardingEmployesFetch=async()=>{
    const response=  await api.get(`api/personal-info/status?status=APPROVED`);
    return response.data;

};
export const onboardingEmployeeVerfication=async(payload)=>{
    const response= await api.post(`api/documents-verification`,payload)
    return response;
}
export const onboardingEmployesPending=async()=>{
    const response=  await api.get(`api/documents-verification/status/INACTIVE`);
    return response;

};

export const onboardingEmployeeUpdate=async(employeeUniqueId,payload)=>{
    await api.patch(`/api/documents-verification/${employeeUniqueId}/update-status`,payload)
}
export const getPersonalInformationEmployee=async(employeeUniqueId)=>{
    const response=await api.get(`/api/documents-verification/${employeeUniqueId}`);
    return response.data;
}